import React, { useState } from "react";
import { Card, Modal } from "antd";
import group from "../../../assets/svg/Group.svg"
import upload from "../../../assets/svg/upload csv.svg";
import { useNavigate } from "react-router-dom";
import AddEntriesModal from "./AddEntriesModal";

const HowToAddAttendanceEntriesModal = ({ open, handleCancel,uploadAttendanceFile,handleFetchData }) => {
  const navigate = useNavigate()

  const [openSingleEntry, setopenSingleEntry] = useState(false);

  function handleCancelSingle() {
    setopenSingleEntry(false);
  }


 async function handleGoToAddAttendance(){
   await setopenSingleEntry(true);
  await handleCancel()
  }

  function handleUploadAttendanceFile(){
    uploadAttendanceFile()
  }
 

  return (
    <>
      <Modal
        className="mod mod-height"
        title="Add Attendance Entries"
        open={open}
        onCancel={handleCancel}
        width={850}
      >
        <div className="grid grid-cols-2 gap-5 p-[41px]">
          <Card className="p-[70px cursor-pointer" onClick={handleGoToAddAttendance}>
            <div className="text-center justify-center flex flex-col ">
              <img
                src={group}
                alt="group"
                className="mx-auto w-[169.002px] h-[161.471px]"
              />

              <span className="text-black text-[20px] font-[500] font-dmSans leading-loose mt-[32px]">
                {" "}
                Complete a Form{" "}
              </span>
            </div>
          </Card>
          <Card className="p-[70px cursor-pointer" onClick={handleUploadAttendanceFile}>
            <div className="text-center justify-center flex flex-col ">
              <img
                src={upload}
                alt="upload"
                className="mx-auto w-[169.002px] h-[161.471px]"
              />

              <span className="text-black text-[20px] font-[500] font-dmSans leading-loose mt-[32px]">
                {" "}
                Import excel file{" "}
              </span>
            </div>
          </Card>
        </div>
      </Modal>
 
      <AddEntriesModal
        handleFetchData={handleFetchData}
        open={openSingleEntry}
        handleCancel={handleCancelSingle}
        prodd=""
      />
    </>
  );
};
export default HowToAddAttendanceEntriesModal;
